import { render } from "./iPhones.vue?vue&type=template&id=51532efe&scoped=true"
import script from "./iPhones.vue?vue&type=script&lang=js"
export * from "./iPhones.vue?vue&type=script&lang=js"

import "./iPhones.vue?vue&type=style&index=0&id=51532efe&lang=scss&scoped=true"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51532efe"]])

export default __exports__